export default __webpack_public_path__ + "static/media/decorate-control.cd2208fd.png";